import { ITheme } from "../../Theme/Theme.types.js";
import { DefaultButtonProps } from "../Button.types.js";

function isShadowColor(theme: ITheme, color: string): color is keyof typeof theme.shadows.button {
    return Object.keys(theme.shadows.button).includes(color);
}
export const getShadow = ({ theme, color, hover = false }: { theme: ITheme; color: DefaultButtonProps["color"]; hover?: boolean }): string => {
    if (isShadowColor(theme, color)) return theme.shadows.button[color][hover ? "hover" : "default"];

    return theme.shadows.button.neutral[hover ? "hover" : "default"];
};
